import React, { useEffect, useState } from "react";
import "../styles/Nav.css";
import { FaBars } from "react-icons/fa6";
import { FaUserCircle } from "react-icons/fa"; // Default profile icon
import Logo from "./Logo";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout, setIsLoggedIn } from "../redux/slices/authSlice";
import { fetchUserThunk } from "../thunks/thunks";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

function Nav() {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const permission = useSelector(
    (state) => state.auth.personalinfo?.permission
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(true);
  const [isConfirmationPopUp, setIsConfirmationPopUp] = useState(false);
  const [isShopDropdownOpen, setIsShopDropdownOpen] = useState(false); // Shop dropdown
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false); // User dropdown
  const [isMoreDropdownOpen, setIsMoreDropdownOpen] = useState(false); // More dropdown

  useEffect(() => {
    dispatch(fetchUserThunk());
    const token = Cookies.get("authToken");
    if (token) {
      dispatch(setIsLoggedIn(true));
    }
  }, [dispatch]);

  const handleLogout = () => {
    setIsConfirmationPopUp(false);
    dispatch(logout());
    toast.success("Logged out successfully");
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  const handleLogin = () => {
    navigate("/register");
  };

  const toggleDropDown = () => {
    setIsOpen((prev) => !prev);
  };
  return (
    <nav className="flex justify-between items-center h-[5.3rem] shadow-md z-100 sticky top-0 z-40 bg-white">
      <Link className="logo m-3 md:mx-[2rem] p-5" to="/">
        <Logo />
      </Link>
      <ul
        className={`text-center poppins absolute ${
          isOpen ? "top-[-100rem]" : "top-[5rem]"
        } w-full flex flex-col gap-[1.5rem] dropdown-menu md:static md:flex-row md:justify-end  md:items-center text-[#949195] bg-white p-5 `}
      >
        {permission === "admin" && (
          <Link to="/admin">
            <li className="p-2 rounded-lg hover:bg-gray-200 hover:text-gray-800">
              Admin
            </li>
          </Link>
        )}
        <Link to="/">
          <li className="p-2 rounded-lg hover:bg-gray-200 hover:text-gray-800">
            Home
          </li>
        </Link>
        {/* Shop Dropdown */}
        <div className="relative md:static w-full md:w-auto">
          <button
            onClick={() => {
              setIsShopDropdownOpen((prev) => !prev);
              setIsMoreDropdownOpen(false);
              setIsUserDropdownOpen(false);
            }}
            className="p-2 rounded-lg hover:bg-gray-200 hover:text-gray-800 w-full md:w-auto text-left md:text-center pl-[43%] md:pl-2 "
          >
            Shop
          </button>
          <div
            className={`w-full md:w-32 bg-white shadow-lg rounded-md transition-all duration-300 ease-in-out overflow-hidden ${
              isShopDropdownOpen
                ? "max-h-60 py-2 opacity-100"
                : "max-h-0 opacity-0"
            } md:absolute md:top-15 md:right-30 md:opacity-100`}
            style={{
              backgroundColor: "rgba(255, 183, 225, 0.4)",
            }}
          >
            <Link to="/shop?category=kidswear">
              <li className="text-black p-2 rounded-lg hover:bg-pink-300">
                Kids
              </li>
            </Link>
            <Link to="/shop?category=menswear">
              <li className="text-black p-2 rounded-lg hover:bg-pink-300">
                Men
              </li>
            </Link>
            <Link to="/shop?category=women">
              <li className="text-black p-2 rounded-lg hover:bg-pink-300">
                Women
              </li>
            </Link>
          </div>
        </div>

        {/* More Dropdown */}
        <div className="relative md:static w-full md:w-auto">
          <button
            onClick={() => {
              setIsMoreDropdownOpen((prev) => !prev);
              setIsUserDropdownOpen(false);
              setIsShopDropdownOpen(false);
            }}
            className="p-2 rounded-lg hover:bg-gray-200 hover:text-gray-800 w-full md:w-auto text-left md:text-center pl-[43%] md:pl-2"
          >
            More
          </button>
          <div
            className={`w-full md:w-32 bg-white shadow-lg rounded-md transition-all duration-300 ease-in-out overflow-hidden ${
              isMoreDropdownOpen
                ? "max-h-60 py-2 opacity-100"
                : "max-h-0 opacity-0"
            } md:absolute md:top-15 md:right-30 md:opacity-100`}
            style={{
              backgroundColor: "rgba(255, 183, 225, 0.4)",
            }}
          >
            <Link to="/about">
              <li className="text-black p-2 rounded-lg hover:bg-pink-300">
                About Us
              </li>
            </Link>
            <Link to="/contact">
              <li className="text-black p-2 rounded-lg hover:bg-pink-300">
                Contact Us
              </li>
            </Link>
            {isLoggedIn && (
              <li
                onClick={() => setIsConfirmationPopUp(true)}
                className="text-black p-2 rounded-lg hover:bg-pink-300 cursor-pointer"
              >
                Logout
              </li>
            )}
            {!isLoggedIn && (
              <li
                onClick={handleLogin}
                className="text-black p-2 rounded-lg hover:bg-pink-300 cursor-pointer"
              >
                Login
              </li>
            )}
          </div>
        </div>

        {/* User Dropdown */}
        <div className="md:static w-full md:w-auto">
          <button
            onClick={() => {
              setIsUserDropdownOpen((prev) => !prev);
              setIsMoreDropdownOpen(false);
              setIsShopDropdownOpen(false);
            }}
            className="p-2 rounded-lg hover:bg-gray-200 hover:text-gray-800 w-full md:w-auto ml-auto pl-[44%]"
          >
            <FaUserCircle size={28} />
          </button>
          <div
            className={`w-full md:w-32 shadow-lg rounded-md transition-all duration-300 ease-in-out overflow-hidden ${
              isUserDropdownOpen
                ? "max-h-60 py-2 opacity-100"
                : "max-h-0 opacity-0"
            } md:absolute md:top-15 md:right-7 md:opacity-100`}
            style={{
              backgroundColor: "rgba(255, 183, 225, 0.4)"
            }}
          >
            <Link to="/profile">
              <li className="p-2 rounded-lg text-black hover:bg-pink-300">Profile</li>
            </Link>
            <Link to="/wishlist">
              <li className="p-2 rounded-lg text-black hover:bg-pink-300">Wishlist</li>
            </Link>
            <Link to="/cart">
              <li className="p-2 rounded-lg hover:bg-pink-300 text-black">Cart</li>
            </Link>
          </div>
        </div>

        {isConfirmationPopUp && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-bold mb-4 text-black">
                Confirm Logout?
              </h2>
              <p className="text-gray-700 mb-4">
                Are you sure you want to logout? You can't access the cart and
                wishlist without logging in!
              </p>
              <div className="flex space-x-4">
                <button
                  onClick={handleLogout}
                  className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                >
                  Logout
                </button>
                <button
                  onClick={() => setIsConfirmationPopUp(false)}
                  className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </ul>
      <div
        onClick={toggleDropDown}
        className="cursor-pointer m-5 toggle-button md:invisible"
      >
        <FaBars size={28} />
      </div>
    </nav>
  );
}

export default Nav;
